import styled, { keyframes } from 'styled-components';
//////////////////////////////////////////////////

const localLoader1 = keyframes`
  0% { transform: scale(0); }
  100% { transform: scale(1); }
`;

const localLoader2 = keyframes`
  0% { transform: translate(0, 0); }
  100% { transform: translate(19px, 0); }
`;

const localLoader3 = keyframes`
  0% { transform: scale(1); }
  100% { transform: scale(0); }
`;

export const Wrapper = styled.div`
  width: 64px;
  height: 64px;
  position: relative;
  display: inline-block;
  & div {
    top: 27px;
    width: 11px;
    height: 11px;
    background: gray;
    position: absolute;
    border-radius: 50%;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }
  & div:nth-child(1) {
    left: 6px;
    animation: ${localLoader1} 0.6s infinite;
  }
  & div:nth-child(2) {
    left: 6px;
    animation: ${localLoader2} 0.6s infinite;
  }
  & div:nth-child(3) {
    left: 26px;
    animation: ${localLoader2} 0.6s infinite;
  }
  & div:nth-child(4) {
    left: 45px;
    animation: ${localLoader3} 0.6s infinite;
  }
`;
